import React from 'react';

export interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'light' | 'dark' | 'gradient';
  elevated?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = '',
  variant = 'light',
  elevated = false,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  // Base glass card class
  const baseClass = 'rounded-xl backdrop-blur-sm transition-all duration-300';
  
  // Variant classes
  const variantClasses = {
    light: 'bg-white/10 border border-white/20',
    dark: 'bg-background-glass border border-white/5',
    gradient: 'gradient-border bg-background-glass',
  };
  
  // Elevation classes
  const elevationClass = elevated 
    ? 'shadow-lg hover:shadow-glow' 
    : 'shadow';
    
  // Clickable classes
  const clickableClass = onClick ? 'cursor-pointer hover:scale-[1.01]' : '';
  
  // Combined classes
  const cardClasses = `
    ${baseClass}
    ${variantClasses[variant]}
    ${elevationClass}
    ${clickableClass}
    ${className}
  `;
  
  return (
    <div 
      className={cardClasses} 
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

export default GlassCard;
